module.exports = {
  "props": [
    {
      "name": "align-baseline",
      "default": "false",
      "source": null,
      "type": "Boolean",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "align-center",
      "default": "false",
      "source": null,
      "type": "Boolean",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "align-content-center",
      "default": "false",
      "source": null,
      "type": "Boolean",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "align-content-end",
      "default": "false",
      "source": null,
      "type": "Boolean",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "align-content-space-around",
      "default": "false",
      "source": null,
      "type": "Boolean",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "align-content-space-between",
      "default": "false",
      "source": null,
      "type": "Boolean",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "align-content-start",
      "default": "false",
      "source": null,
      "type": "Boolean",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "align-end",
      "default": "false",
      "source": null,
      "type": "Boolean",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "align-start",
      "default": "false",
      "source": null,
      "type": "Boolean",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "column",
      "type": "boolean",
      "default": "false",
      "source": null,
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "d-{type}",
      "default": "false",
      "source": null,
      "type": "Boolean",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "fill-height",
      "default": "false",
      "source": null,
      "type": "Boolean",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "id",
      "type": "string",
      "default": "undefined",
      "source": "v-layout",
      "description": {
        "en": "Sets the DOM id on the component",
        "ja": "コンポーネントにDOM idを設定します",
        "zh-Hans": "设置组件上的 DOM id"
      }
    },
    {
      "name": "justify-center",
      "default": "false",
      "source": null,
      "type": "Boolean",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "justify-end",
      "default": "false",
      "source": null,
      "type": "Boolean",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "justify-space-around",
      "default": "false",
      "source": null,
      "type": "Boolean",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "justify-space-between",
      "default": "false",
      "source": null,
      "type": "Boolean",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "justify-start",
      "default": "false",
      "source": null,
      "type": "Boolean",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "reverse",
      "type": "boolean",
      "default": "false",
      "source": null,
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "row",
      "type": "boolean",
      "default": "true",
      "source": null,
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "tag",
      "type": "String",
      "default": "div",
      "source": null,
      "description": {
        "en": "Specify a custom tag used on the root element.",
        "ja": "コンポーネント内で使用するカスタムタグを指定します。",
        "zh-Hans": "指定在根元素上使用的自定义标签。"
      }
    },
    {
      "name": "wrap",
      "type": "boolean",
      "default": "false",
      "source": null,
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    }
  ],
  "mixins": [],
  "slots": [
    {
      "name": "default",
      "description": {
        "en": "The default Vue slot.",
        "ja": "デフォルトの Vue slot",
        "zh-Hans": "默认Vue 插槽。"
      }
    }
  ],
  "events": [],
  "functions": [],
  "name": "v-layout",
  "sass": [],
  "component": true
}